export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11970.b0d46ac2.jpg";